module.exports = __webpack_public_path__ + "static/img/3163.ae96d569.jpg";